"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactButtonsRoot = exports.CarouselSlideRoot = exports.CarouselRoot = exports.CarouselInner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../constants");
var _utils = require("../utils");
const CarouselRoot = exports.CarouselRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isTouchActive,
  navigation,
  width,
  hasFocusableSlides
}) => ({
  padding: (0, _utils.getCarouselRootPadding)({
    navigation
  }),
  position: 'relative',
  width,
  '&:hover .active-pagination-step': {
    animation: 'none'
  },
  ...(isTouchActive ? {
    '.active-pagination-step': {
      animation: 'none'
    }
  } : null),
  '.keen-slider:not([data-keen-slider-disabled])': {
    alignContent: 'flex-start',
    display: 'flex',
    KhtmlUserSelect: 'none',
    msTouchAction: 'pan-y',
    overflow: 'hidden',
    position: 'relative',
    touchAction: 'pan-y',
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    width: '100%',
    [`.${_constants.SLIDE_CLASSNAME}`]: {
      minHeight: '100%',
      overflow: hasFocusableSlides ? undefined : 'hidden',
      position: 'relative',
      width: '100%'
    },
    '&[data-keen-slider-reverse]': {
      flexDirection: 'row-reverse'
    },
    '&[data-keen-slider-v]': {
      flexWrap: 'wrap'
    }
  }
}));
const CarouselInner = exports.CarouselInner = (0, _mui.styled)('div')(({
  hasFocusableSlides
}) => ({
  cursor: 'grab',
  padding: hasFocusableSlides ? '2px' : undefined,
  '&:active': {
    cursor: 'grabbing'
  }
}));
const CarouselSlideRoot = exports.CarouselSlideRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  minWidth
}) => ({
  maxWidth: 'fit-content',
  minWidth: typeof minWidth === 'number' ? `${minWidth}px` : minWidth
}));
const CompactButtonsRoot = exports.CompactButtonsRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginTop: theme.spacing(6)
}));
//# sourceMappingURL=root.js.map